import { Box, styled } from "@mui/material";

const ManagementPage = styled(Box)(({ theme }) => ({
  width: "100%",
  marginTop: 10,
  [theme.breakpoints.down("sm")]: {
    marginTop: 0,
    paddingTop: 88,
  },
}));

const ManagementHeading = styled("h1")(({ theme }) => ({
  marginTop: 0,
  marginBottom: 16,
  color: "#161C28",
  fontSize: 28,
  fontWeight: 800,
  [theme.breakpoints.down("sm")]: {
    marginBottom: 12,
    fontSize: 22,
  },
}));

const ManagementTable = styled(Box)({
  width: "100%",
  overflow: "hidden",
  border: "1px solid #E8EDF2",
  borderRadius: 8,
  backgroundColor: "#FFFFFF",
  "& .ant-table": {
    backgroundColor: "transparent",
  },
  "& .ant-table-cell": {
    whiteSpace: "nowrap",
  },
});

export { ManagementPage, ManagementHeading, ManagementTable };
